// src/composables/useViewport.ts
import { ref, computed, onMounted, onUnmounted } from 'vue';

export function useViewport() {
  const width = ref(window.innerWidth);

  const onResize = () => {
    width.value = window.innerWidth;
  };

  onMounted(() => window.addEventListener('resize', onResize));
  onUnmounted(() => window.removeEventListener('resize', onResize));

  const breakpoint = computed<'mobile' | 'tablet' | 'desktop'>(() => {
    if (width.value < 768) return 'mobile';
    if (width.value < 1024) return 'tablet';
    return 'desktop';
  });

  return { breakpoint };
}
